__turbopack_context__.v({
  "className": "lato_fabe8db4-module__KY6Drq__className",
});
